module.exports = __webpack_public_path__ + "img/icon-drag.fb704614.svg";